import {gql} from 'apollo-boost';

export const GET_EXAM = gql`
  query getExam($id : ID!){
    getExam (
      id: $id
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const GET_EXAMS_BY_FILTER = gql`

  query getExamsByFilter($vdoLiveSetFilterInput: ExamFilterInput){
    getExamsByFilter (
      examFilterInput:$vdoLiveSetFilterInput
    ){
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const GET_EXAMS = gql`
  query getExams {
    getExams {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const ADD_EXAM = gql`
  mutation addExam(
    $vdoLiveSetId: ID!
    $examInput: ExamInput!
  ) {
    addExam(
      vdoLiveSetId: $vdoLiveSetId
      examInput: $examInput
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const ADD_EXAMS_UPLOAD = gql`
  mutation addExamsUpload(
    $subjectId: ID!,
    $teacherId: ID!,
    $courseOutlineId: ID!,
    $examQuestionTypeId: ID!,
    $allowDuplicateQuestion: Boolean,
    $examsUploadInput: [ExamsUploadInput]
  ) {
    addExamsUpload(
      subjectId: $subjectId
      teacherId: $teacherId
      courseOutlineId: $courseOutlineId
      examQuestionTypeId: $examQuestionTypeId
      allowDuplicateQuestion: $allowDuplicateQuestion
      examsUploadInput: $examsUploadInput
    ) {
      successCount
      failCount
      resultAddExamsUpload{
        no unitSeq question score answer
        choice1 choice2 choice3 choice4
        isRandom status remark
      }
    }
  }
`;

export const UPDATE_EXAM = gql`
  mutation updateExam(
    $id: ID!,
    $examInput: ExamInput!
  ) {
    updateExam(
      id: $id
      examInput: $examInput
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const DELETE_EXAM = gql`
  mutation deleteExam($id: ID!) {
    deleteExam(
      id: $id
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;

export const DELETE_ALL_EXAM_QUESTION_BY_EXAM_ID = gql`
  mutation deleteAllExamQuestionByExamId($id: ID!) {
    deleteAllExamQuestionByExamId(
      id: $id
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath }
    }
  }
`;


export const BULK_ADD_EXAMQUESTION = gql`
  mutation bulkAddExamQuestion(
    $workbook: [[ExamQuestionSetInput]]
  ) {
    bulkAddExamQuestion (
      workbook: $workbook
    )
    {
      totalSuccess
      totalFail
    }
  }
`;

export const GET_EXAM_LIST = gql`
  query getExams {
    getExams {
      id
      degree {
        id
      }
      degreeCode
      subjectGroup {
        id
      }
      subjectGroupCode
      subject {
        id
        code
        nameLocal
      }
      subjectCode
      teacher {
        id
        code
        firstNameLocal
        lastNameLocal
      }
      teacherCode
      QuestionQty
      QuestionMultiQty
      QuestionTrueFalseQty
    }
  }
`;

export const GET_EXAMS_PAGINATION = gql`
  query examsPagination(
    $filter: String
    $where: ExamFilterInput
    $pageSize: Int
    $currentPage: Int
    $orderBy: ExamsOrderByInput!) {
    examsPagination(
      filter: $filter
      where: $where
      pageSize: $pageSize
      currentPage: $currentPage
      orderBy: $orderBy
    ) {
      nodes {
        id
        degree {
          id
          nameLocal
        }
        degreeCode
        subjectGroup {
          id
          nameLocal
        }
        subjectGroupCode
        subject {
          id
          code
          nameLocal
        }
        subjectCode
        teacher {
          id
          code
          firstNameLocal
          lastNameLocal
          picturePath
        }
        teacherCode
        QuestionQty
        QuestionMultiQty
        QuestionTrueFalseQty
      }
      pageInfo {
        fromItem
        toItem
        currentPage
        pageSizes
        totalItemsInPage
        totalPage
        totalItems
      }
    }
  }
`;

